// GlobalDropdown.js
import React from "react";
import ReactDOM from "react-dom";
import { useDropdown } from "./DropdownContext";
import styled from "@emotion/styled";

const GlobalDropdown = () => {
  const { dropdownData, closeDropdown } = useDropdown();

  if (!dropdownData.isOpen) return null;

  const { content, position } = dropdownData;

  return ReactDOM.createPortal(
    <Styled
      className="global-dropdown"
      style={{
        position: "absolute",
        top: position?.top || 0,
        left: position?.left || 0,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="dropdown-content">{content}</div>
      <div className="dropdown-backdrop" onClick={closeDropdown}></div>
    </Styled>,
    document.body
  );
};

const Styled = styled.div`
  z-index: 1000;

  .dropdown-content {
    background: white;
    border: 1px solid #ddd;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 10px;
    border-radius: 4px;
    position: relative;
    z-index: 1000;
  }

  .dropdown-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 900;
    background: transparent;
  }
`;

export default GlobalDropdown;
